<template>
    <div class="select-existing-media">
        <div class="search-filter">
            <div class="search-left-options">
                <b-button type="is-light" icon-left="arrow-left" @click="goBack">
                    Back
                </b-button>
            </div>
            <div class="search-right-options">
                <b-field>
                    <b-input v-model="searchQuery" placeholder="Search media..." type="search" icon="magnify"></b-input>
                </b-field>
            </div>
        </div>
        <div v-if="!loading" class="search-body-container">
            <div class="media-grid">
                <div v-for="item in mediaItems" :key="item.id" class="media-item">
                    <uploadedCard :canDelete="false" @playMedia="playMedia(item)" :key="item.id" :dataObj='item'
                        @click="selectMedia(item)" />
                </div>
            </div>

            <div v-if="mediaItems.length === 0" class="no-results">
                <p>No media files found</p>
            </div>

            <div class="pagination">
                <b-pagination v-model="currentPage" :total="total" :per-page="perPage" @change="fetchMedia"
                    order="is-centered">
                </b-pagination>
            </div>
        </div>

        <div v-if="loading" class="search-body-container">
            <div class="loading-state">
                <b-loading :is-full-page="false" :active="true"></b-loading>
            </div>
        </div>



        <!-- ClapprPlayer -->
        <b-modal v-model="show_player" :width="800">
            <div style="height: 500px" v-if="selected_media">
                <ClapprPlayer :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${selected_media.videoPath}`" type="hls">
                </ClapprPlayer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { GET_STREAMER_MEDIA } from '@/store/actions/audvisual';
import uploadedCard from './uploadedCard.vue';

export default {
    name: 'SelectExistingMedia',
    components: { uploadedCard },
    data() {
        return {
            searchQuery: '',
            mediaItems: [],
            selectedItem: null,
            loading: false,
            currentPage: 1,
            total: 0,
            perPage: 12,
            show_player: false,
            selected_media: null
        }
    },
    watch: {
        searchQuery: {
            handler: 'debouncedFetch',
            debounce: 300
        }
    },
    methods: {
        goBack() {
            this.$emit('back');
        },
        playMedia(item) {
            this.show_player = true;
            this.selected_media = item;
        },
        async fetchMedia() {
            this.loading = true;
            try {
                const params = {
                    page: this.currentPage,
                    per_page: this.perPage,
                    search: this.searchQuery,
                    status: 'completed'
                };

                const response = await this.$store.dispatch(GET_STREAMER_MEDIA, params);
                if (response.data) {
                    this.mediaItems = response.data.items;
                    this.total = response.data.total;
                }
            } catch (error) {
                this.$notify({
                    group: "status",
                    type: "error",
                    title: "Error",
                    text: 'Failed to fetch media files',
                });
            } finally {
                this.loading = false;
            }
        },
        debouncedFetch() {
            this.currentPage = 1;
            this.fetchMedia();
        },
        selectMedia(item) {
            this.selectedItem = item;
            this.$emit('selected', item);
        }
    },
    filters: {
        formatDate(value) {
            if (!value) return '';
            return new Date(value).toLocaleDateString();
        }
    },
    created() {
        this.fetchMedia();
    }
}
</script>

<style lang="scss" scoped>
.select-existing-media {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    .search-filter {
        width: 100%;
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .search-body-container {
        height: calc(100% - 60px);

        .media-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 20px;
            flex: 1;

            .media-item {
                border: 1px solid #eee;
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }

                &.selected {
                    border-color: #3273dc;
                    box-shadow: 0 0 0 2px #3273dc;
                }

                .thumbnail {
                    position: relative;
                    padding-top: 56.25%;
                    background: #f5f5f5;

                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .duration {
                        position: absolute;
                        bottom: 8px;
                        right: 8px;
                        background: rgba(0, 0, 0, 0.7);
                        color: white;
                        padding: 2px 6px;
                        border-radius: 4px;
                        font-size: 12px;
                    }
                }

                .media-info {
                    padding: 10px;

                    h3 {
                        font-size: 14px;
                        margin-bottom: 4px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    p {
                        font-size: 12px;
                        color: #666;
                    }
                }
            }
        }

        .pagination {
            margin-top: 20px;
            margin-bottom: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .no-results {
            text-align: center;
            padding: 40px;
            color: #666;
        }

        .loading-state {
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 200px;
        }
    }
}
</style>